import data from "../../.sourceflow/career_advice.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const career_advice_helper = new CollectionHelper(data);
